/**
 * Redux
 */
import { createSearchParams } from "react-router-dom";
import { initialSearchForm, ISearchForm, IFlight } from "redux/searchForm";

/**
 * Shared Utils
 */

/**
 * Validation
 */
import {
  isOutdatedMetaSearchQuery,
  isValidMetaSearchQuery,
} from "../validation/validateMetaRequest";
import { deepCloneObject } from "@thekilroygroup/shared-ui";

const buildQueryString: any = (
  clonedSearchForm: ISearchForm,
  addMetaQueryParams: boolean = false,
  itineraryId: string = "",
) => {
  const {
    searchRequestId,
    topLevelDomain,
    utm_source,
    utm_campaign,
    utm_medium,
    utm_content,
    hmac,
    mktPortal,
    totalPrice,
    adultPrice,
    childPrice,
    infantPrice,
    clickId,
    timestampInSeconds,
    fareId,
    airlines,
    passengers,
    cabinClass,
    flights,
    flexibleSearch,
    tripType,
  } = clonedSearchForm;

  let params: IMetapartnerQuerystring = {};

  if (
    topLevelDomain !== null &&
    topLevelDomain !== initialSearchForm.topLevelDomain
  ) {
    params.topLevelDomain = topLevelDomain;
  }

  if (searchRequestId !== null) {
    params.searchRequestId = searchRequestId;
  }
  if (itineraryId !== "") {
    params.fareId = itineraryId;
  } else if (fareId !== null) {
    params.fareId = fareId;
  }
  if (airlines !== null) {
    params.airlines = airlines.join();
  }

  if (passengers.adults !== null) {
    params.adults = passengers.adults;
  }

  if (passengers.children !== null) {
    params.children = passengers.children;
  }

  if (passengers.children !== null) {
    params.children = passengers.children;
  }

  if (passengers.infants !== null) {
    params.infants = passengers.infants;
  }

  if (cabinClass !== null) {
    params.cabinClass = cabinClass;
  }

  if (flexibleSearch !== 0) {
    params.flexibleSearch = flexibleSearch;
  }

  if (tripType !== null && tripType) {
    params.tripType = tripType;
  }

  if (flights !== null) {
    if (params.tripType === "MULTI_DEST") {
      flights.forEach((flight: IFlight, i: number) => {
        if (flight.departure !== null) {
          const param = `leg${i + 1}From`;
          params[param] = flight.departure;
        }

        if (flight.arrival !== null) {
          const param = `leg${i + 1}To`;
          params[param] = flight.arrival;
        }

        if (flight.departureDate !== null) {
          const param = `leg${i + 1}Date`;
          params[param] = flight.departureDate;
        }
      });
    } else if (tripType === "ONE_WAY") {
      /**
       * Case tripType === oneway
       */
      const flight: IFlight = flights[0];

      if (flight.departure !== null) {
        params.outFrom = flight.departure;
      }

      if (flight.arrival !== null) {
        params.outTo = flight.arrival;
      }

      if (flight.departureDate !== null) {
        params.outDate = flight.departureDate;
      }
    } else if (tripType === "RETURN") {
      /**
       * Case tripType === oneway OR tripType === return
       */
      const flight: IFlight = flights[0];

      if (flight.departure !== null) {
        params.outFrom = flight.departure;
      }

      if (flight.arrival !== null) {
        params.outTo = flight.arrival;
      }

      if (flight !== null && flight.departureDate !== null) {
        params.outDate = flight.departureDate;
      }

      if (
        flights.length > 1 &&
        flights[1] !== null &&
        flights[1].departureDate !== null
      ) {
        params.retDate = flights[1].departureDate;
      }
    }
  }

  if (
    addMetaQueryParams &&
    isValidMetaSearchQuery(clonedSearchForm) &&
    !isOutdatedMetaSearchQuery(clonedSearchForm)
  ) {
    if (utm_source !== null) {
      params.utm_source = utm_source;
    }

    if (hmac !== null) {
      params.hmac = hmac;
    }

    if (utm_campaign !== null) {
      params.utm_campaign = utm_campaign;
    }

    if (utm_medium !== null) {
      params.utm_medium = utm_medium;
    }

    if (utm_content !== null) {
      params.utm_content = utm_content;
    }

    if (mktPortal !== null) {
      params.mktPortal = mktPortal;
    }

    if (totalPrice !== null) {
      params.totalPrice = totalPrice;
    }

    if (adultPrice !== null) {
      params.adultPrice = adultPrice;
    }

    if (childPrice !== null) {
      params.childPrice = childPrice;
    }

    if (infantPrice !== null) {
      params.infantPrice = infantPrice;
    }

    if (clickId !== null) {
      params.clickId = clickId;
    }

    if (timestampInSeconds !== null) {
      params.timestampInSeconds = timestampInSeconds;
    }
  }
  const nextParams: string = `${createSearchParams(deepCloneObject(params))}`;

  return nextParams;
};

export { buildQueryString };

interface IMetapartnerQuerystring {
  [key: string]: any;
  topLevelDomain?: string;
  fareId?: string;
  utm_source?: string;
  utm_campaign?: string;
  utm_medium?: string;
  utm_content?: string;
  mktPortal?: string;
  totalPrice?: number;
  adultPrice?: number;
  childPrice?: number;
  infantPrice?: number;
  clickId?: string;
  timestampInSeconds?: number;
  airlines?: string; // Comma seperated string KENNETH?

  adults?: number; // Min 1, max 9
  children?: number; // Max 9
  infants?: number; // Max 9

  outFrom?: string; //IATA
  outTo?: string; //IATA
  departureDate?: string; // dd.MM.yyyy
  returnFrom?: string; //IATA
  returnTo?: string; //IATA
  returnDate?: string; // dd.MM.yyyy

  cabinClass?:
    | "ECONOMY"
    | "PREMIUM_ECONOMY"
    | "BUSINESS"
    | "FIRST"
    | "PREMIUM_BUSINESS"
    | "PREMIUM_FIRST"; // First is default
  tripType?: "RETURN" | "ONE_WAY" | "MULTI_DEST"; // ENUM or STRING KENNETH?

  leg1From?: string; //IATA
  leg1To?: string; //IATA
  leg1Date?: string; // dd.MM.yyyy
  leg2From?: string; //IATA
  leg2To?: string; //IATA
  leg2Date?: string; // dd.MM.yyyy
  leg3From?: string; //IATA
  leg3To?: string; //IATA
  leg3Date?: string; // dd.MM.yyyy
  leg4From?: string; //IATA
  leg4To?: string; //IATA
  leg4Date?: string; // dd.MM.yyyy
  leg5From?: string; //IATA
  leg5To?: string; //IATA
  leg5Date?: string; // dd.MM.yyyy
  leg6From?: string; //IATA
  leg6To?: string; //IATA
  leg6Date?: string; // dd.MM.yyyy
  leg7From?: string; //IATA
  leg7To?: string; //IATA
  leg7Date?: string; // dd.MM.yyyy
  leg8From?: string; //IATA
  leg8To?: string; //IATA
  leg8Date?: string; // dd.MM.yyyy
  leg9From?: string; //IATA
  leg9To?: string; //IATA
  leg9Date?: string; // dd.MM.yyyy
  leg10From?: string; //IATA
  leg10To?: string; //IATA
  leg10Date?: string; // dd.MM.yyyy
}

export const getShareUrl = (
  searchForm: ISearchForm,
  addMetaQueryParams: boolean,
  itineraryId: string,
) => {
  const origin = window.location.origin;
  const path = location.pathname;
  return `${origin}${path}?${buildQueryString(
    searchForm,
    addMetaQueryParams,
    itineraryId,
  )}`;
};
